export const SALESVIEW = 'salesview';

export enum API_NAMES {
  PORTAL = 'portal',
  API_PUBLIC = 'api-public',
}
